import vtranscript from './videojs-transcript'

export default vtranscript
